import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { KeeniconComponent } from '../../partials';

@Component({
  selector: 'ui-form-radio',
  imports: [ReactiveFormsModule, KeeniconComponent],
  templateUrl: './form-radio.component.html',
  styleUrl: './form-radio.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormRadioComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  iconName = input<string>('');
  name = input<string>('');
  description = input<string>('');
  id = input<string | number>('');
  value = input<string | number>('');
  inlineRadio = input<boolean>(false);

  get formControl(): FormControl {
    return this.control() as FormControl;
  }
}
